export const dark = {
  // main
  mainBackgroundColor: "#111111",
  mainFontColor: "white",
  //// component
  disableColor: "#818181",
  backgroundColor: "#000000",
  boxShadow: "#333333",
};

// ${(props) => props.theme.boxShadow}
